import React, { memo, useContext } from 'react'
import { Link } from 'gatsby'
import { FiChevronRight, FiBook } from 'react-icons/fi'

import style from './CategoryNav.module.scss'

import MicrocopyContext from '~contexts/MicrocopyContext'

const CategoryNav = ({
  page
}) => {
  const show = page.category?.subcategories?.[0] || page.category?.subPages?.[0]
  const microcopy = useContext(MicrocopyContext)

  return (
    <>
      { show && (
        <nav className={style.sidebar}>
          <div>
            <header>
              <Link to={page.category.path} activeClassName={style.active} partiallyActive>
                { page.category.title }
              </Link>   
            </header>

            { page.category.quickstarts?.map(quickstart => (
              <QuickStart microcopy={microcopy} key={quickstart.id} page={page} quickstart={quickstart} />
            ))}  

            { page.category.subPages?.map(subPage => (
              <Link key={subPage.id} to={subPage.path} activeClassName={style.active}>
                <span>{ subPage.title }</span>
              </Link>
            ))}

            { page.category.subcategories?.map(subcategory => (
              <section key={subcategory.id} data-active={page.path.startsWith(subcategory.path)}>
                <header>
                  <Link to={subcategory.path} activeClassName={style.active} partiallyActive>
                    <span>{ subcategory.title }</span><FiChevronRight />
                  </Link>
                </header>
                { subcategory.quickstarts?.map(quickstart => (
                  <QuickStart microcopy={microcopy} key={quickstart.id} page={page} quickstart={quickstart} nested />
                ))}
                { subcategory.subPages?.map(subPage => (
                  <Link key={subPage.id} to={subPage.path} activeClassName={style.active} data-nested>
                    <span>{ subPage.title }</span>
                  </Link>
                ))}
              </section>
            ))}
          </div>
        </nav>
      )}
    </>
  )
}

const QuickStart = ({
  quickstart,
  page,
  microcopy,
  nested = false
}) => (
  <section className={style.quickstart} data-active={page.path.startsWith(quickstart.path)} data-small={nested} data-nested={nested}>  
    <header>
      <Link to={quickstart.path} activeClassName={style.active} partiallyActive data-with-label>
        <span>{ quickstart.title }
          <em><FiBook />{ microcopy.text('guides.titles.quick_start_guide') }</em>
        </span><FiChevronRight />
      </Link>
    </header>
    <section>
      { quickstart.subPages?.map(subPage => (
        <Link key={subPage.id} to={subPage.path} activeClassName={style.active} data-nested>
          <span>{ !subPage.hideStepNumber && `${subPage.stepNumber}. ` }{ subPage.title }</span>
        </Link>
      ))}
    </section>
  </section>
)

export default memo(CategoryNav)
